import Swiper from '../../scripts/vendor/swiper-bundle';

function initSwiper(swiperEl = null) {
  if (swiperEl) {
    initSwiperEl(swiperEl);
    return;
  }
  const swiperEls = document.querySelectorAll('.swiper:not([thumbsSlider])');

  swiperEls.forEach((swiperEl) => {
    initSwiperEl(swiperEl);
  });
}


function initSwiperEl(swiperEl) {
  const options = JSON.parse(swiperEl.dataset.swiper || {});
  const swiper = new Swiper(swiperEl, { ...options });
  const thumbsSwiperEl = swiperEl.parentElement.querySelector('.swiper[thumbsSlider]');
  if (thumbsSwiperEl) {
    adjustSwiper3dHeight(swiperEl, thumbsSwiperEl);
    swiper.on('slideChange', function () {
      if (swiper.activeIndex === 0) {
        swiper.allowTouchMove = false;
      } else {
        swiper.allowTouchMove = true;
      }
    });

    if (swiper.activeIndex === 0) {
      swiper.allowTouchMove = false;
    }

    // main-product-swiper
    const swiperSlides = thumbsSwiperEl.querySelectorAll('.swiper-slide');
    if (swiperSlides) {
      swiperSlides.forEach((swiperSlide) => {
        swiperSlide.addEventListener('mouseover', () => {
          const isActive = swiperSlide.classList.contains('swiper-slide-thumb-active');
          const ariaLabel = swiperSlide.getAttribute('aria-label');
          if (ariaLabel && !isActive) {
            const sliderIndex = parseInt(ariaLabel.split('/')[0].replace(/\s/g, '')) - 1;
            swiper.slideToLoop(sliderIndex, 0, false);
          }
        });
      });
    }

    // Check if 3D model is expected but not available
    const fibblLayer = swiperEl.querySelector('fibbl-layer');
    if (fibblLayer && typeof Fibbl !== 'undefined') {
      const productId = fibblLayer.getAttribute('data-product-id');
      if (productId) {
        Fibbl.checkModelAvailability(productId).then((isAvailable) => {
          if (!isAvailable) {
            // Remove Fibbl placeholder slide and corresponding thumbnail
            const fibblSlide = swiperEl.querySelector('.swiper-slide[data-fibbl-slide]');
            const fibblThumb = thumbsSwiperEl?.querySelector('.swiper-slide[data-fibbl-slide]');
            if (fibblSlide) fibblSlide.remove();
            if (fibblThumb) fibblThumb.remove();
            swiper.update();
            if (swiper.thumbs) swiper.thumbs.update();
          }
        }).catch(() => {
          // Fibbl check failed (network error) — remove 3D placeholder slide
          const fibblSlide = swiperEl.querySelector('.swiper-slide[data-fibbl-slide]');
          const fibblThumb = thumbsSwiperEl?.querySelector('.swiper-slide[data-fibbl-slide]');
          if (fibblSlide) fibblSlide.remove();
          if (fibblThumb) fibblThumb.remove();
          swiper.update();
          if (swiper.thumbs) swiper.thumbs.update();
        });
      }
    }
  }

  const zoomEls = swiperEl.querySelectorAll('.image-magnify-click');
  zoomEls.forEach((zoomEl) => {
    zoomEl.addEventListener('mouseover', (e) => {
      swiper.zoom.in();
    });
    zoomEl.addEventListener('mouseout', (e) => {
      swiper.zoom.out();
    });
  });
}
function adjustSwiper3dHeight(swiperEl, thumbsSwiperEl) {
  const swiperWrapperHeight = swiperEl.offsetHeight;
  const fibblImageWrapper = swiperEl.querySelector('.fibbl-image-wrapper');
  if (!fibblImageWrapper) return;
  const swiperSlide = fibblImageWrapper.closest('.swiper-slide');
  if (!swiperWrapperHeight || !swiperSlide) return;
  swiperSlide.style.height = swiperWrapperHeight + 'px';
  fibblImageWrapper.style.height = swiperWrapperHeight + 'px';
}


document.addEventListener('DOMContentLoaded', () => initSwiper());
document.addEventListener('update-swiper', () => initSwiper());

export default initSwiper;
